export const getQueryParam = (name: string): string | null => {
    if ( typeof window === 'undefined' || !name) return null;
    const URLParams = new URLSearchParams(window.location.search);
    return URLParams.get(name);
};